// action constants
import Vue from 'vue'
import { StoreMutations } from './mutations';
import SwiftSpaceRepository from '../../../../api/SwiftSpaceRepository';

export const StoreActions = {
    search: 'search',
    update: 'update',
    clearState:'clearState'
};

export const actions = {
    [StoreActions.search](context) {
        SwiftSpaceRepository.searchPlaylists()
        .then((data) => {
            context.commit(StoreMutations.SET_RESULTS, data.playlists)
        })
        .catch((err) => {
            Vue.prototype.$notify({'type':'danger','content':err})
        });
    },
    [StoreActions.update](context, data) {
        SwiftSpaceRepository.updatePlaylist(data.id, data)
            .then(() => {
                context.dispatch(StoreActions.search);
            })
            .catch((err) => {
                Vue.prototype.$notify({'type':'danger','content':err})
            });
    },
    clearState(context) {
        context.commit(StoreMutations.SET_RESULTS,[]);
        context.commit(StoreMutations.SET_PAGE,0);
    }
};
